// extracted by mini-css-extract-plugin
export default {"PhotoPart":"PhotoPart_PhotoPart__lYkP8","PhotoPart_inner":"PhotoPart_PhotoPart_inner__Z2ARo","photo_images":"PhotoPart_photo_images__0jwlI"};